import * as React from 'react'
import { IStageProps, IPoint } from 'app/types'
import Clock from 'app/comp/clock'
import Combo from 'app/comp/combo'
import StageCounter from 'app/comp/stage-counter'
import Hint from 'app/comp/hint'
import DocumentEventHandler from 'app/comp/document-event-handler'


export default class extends React.Component<IStageProps, {
  p: IPoint
  a: number
  isDownPressed: boolean
  isUpPressed: boolean
  isLeftPressed: boolean
  isRightPressed: boolean
}> {

  constructor(props) {
    super(props)

    this.state = {
      p: {x: 0, y: 0},
      a: 90,
      isDownPressed: false,
      isUpPressed: false,
      isLeftPressed: false,
      isRightPressed: false
    }
  }

  componentDidMount() {
    this.loop()
  }

  loop() {
    const { isUpPressed, isDownPressed, isRightPressed, isLeftPressed, a, p } = this.state

    if (isRightPressed) {
      this.setState({a: a + 0.3})
    }

    if (isLeftPressed) {
      this.setState({a: a - 0.3})
    }

    if (isUpPressed) {
      this.setState({p: {x: p.x, y: p.y - 0.3}})
    }

    if (isDownPressed) {
      this.setState({p: {x: p.x, y: p.y + 0.3}})
    }

    requestAnimationFrame(() => this.loop())
  }

  handleKeyUp = event => {
    switch (event.which) {
      case 38:
        this.setState({isUpPressed: false})
        break
      case 40:
        this.setState({isDownPressed: false})
        break
      case 37:
        this.setState({isLeftPressed: false})
        break
      case 39:
        this.setState({isRightPressed: false})
        break
    }
  }

  handleKeyDown = event => {
    switch (event.which) {
      case 38:
        this.setState({isUpPressed: true})
        break
      case 40:
        this.setState({isDownPressed: true})
        break
      case 37:
        this.setState({isLeftPressed: true})
        break
      case 39:
        this.setState({isRightPressed: true})
        break
    }
  }

  getHintText(): string {
    return "A couple steps down and half-way around. That's the *key*. Then an equation, I should see."
  }

  render() {
    const {
      p,
      a
    } = this.state

    const transform = `translate(${p.x} ${p.y}) rotate(${-a}) scale(1 -1) rotate(${a}) translate(${-p.x} ${-p.y})` //

    const dx = 5 * Math.cos(-a * D2R)
    const dy = 5 * Math.sin(-a * D2R)
    const x1 = p.x - dx
    const x2 = p.x + dx
    const y1 = p.y - dy
    const y2 = p.y + dy

    const pathDef = `
      M -40 0

      h 10
      v 10
      h -10

      m 15 -10
      v 10

      m 5 -10
      h 10
      v 10
      h -10
      v -10
      h 10

      m 5 0
      l 5 10
      l 5 -10

      m 5 0
      v 10

      m 5 0
      v -10
      h 10
      v 10

      m 5 -5
      h 10

    `

    return (
      <div className="container">

        <DocumentEventHandler
          onKeyDown={this.handleKeyDown}
          onKeyUp={this.handleKeyUp}
        />

        <Hint
          onAddTime={this.props.onAddTime}
          delay={1 * 60 * 1000}
          text={this.getHintText()}
        />

        <StageCounter info={this.props.stageInfo} />

        <Clock time={this.props.time} />

        <svg
          width="700"
          height="700"
          viewBox="-100 -100 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d={pathDef} stroke="#222" fill="none" strokeWidth="1" strokeLinecap="square" />

          <g transform={transform}>
            <path d={pathDef} stroke="#222" fill="none" strokeWidth="1" strokeLinecap="square" />
          </g>

          <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#222" strokeWidth="1" />
        </svg>

        <div style={{position: 'absolute', bottom: 12, left: 0, width: '100vw', textAlign: 'center'}}>
          <Combo code="3180" onSolve={this.props.onNext} />
        </div>
      </div>
    )
  }

}


const D2R = Math.PI/180


// WEBPACK FOOTER //
// ./src/stage/mirror.tsx